export default __webpack_public_path__ + "static/media/ic_info.b525164e.svg";